import { queryOptions } from '@tanstack/vue-query'
import merge from 'lodash/merge'
import { queryClient } from '@/plugins/tanstack'
import { fetchUsersV3 } from '@/common/services/UsersService'
import { invalidateQuery, queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { SERVER_DATA_SCOPE, type FetchOptionBase } from '@/common/types/cacheConstants'
import { type UserParamsDTOV3 } from '@/common/types/users'

function groupOptions(
  params: UserParamsDTOV3 = {
    'include-deactivated': true,
  },
) {
  return queryOptions({
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.USERS,
      params,
    }),
    staleTime: Infinity,
    queryFn: () => {
      return fetchUsersV3(params['include-deactivated'], params.expand, params.include)
    },
  })
}

interface FetchOption extends FetchOptionBase {
  params?: UserParamsDTOV3
}
async function fetch(options: FetchOption = {}) {
  const { params, staleTime } = options
  const [result] = await Promise.all([queryClient.fetchQuery(merge(groupOptions(params), { staleTime }))])
  return result
}

function invalidate() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.USERS,
    }),
  ])
}

export default {
  fetch,
  groupOptions,
  invalidate,
}
